import { combineReducers } from "@reduxjs/toolkit";

import { dataAction, dataReducer, dataState } from "./data";
import { errorsAction, errorsReducer, errorsState } from "./errors";
import { filtersAction, filtersReducer, filtersState } from "./filters";

export type StateServices = {
	data: dataState;
	errors: errorsState;
	filters: filtersState;
};

export const services = combineReducers<StateServices>({
	data: dataReducer,
	errors: errorsReducer,
	filters: filtersReducer,
});

export const servicesAction = {
	data: dataAction,
	errors: errorsAction,
	filters: filtersAction,
};

export default services;
